(ns portal.user-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.modal.dialog :refer [form-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [portal.user-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui form-field-email [{:keys [mode]}]
  (let [{:keys [value] :as control} (form/use-bind-control [:email])]
    ($ form-field
       {:label "Email address"
        :err-msg (form/use-error-message [:email])}
       (if (= mode :edit)
         ($ :p value)
         ($ input
            (merge control
                   {:type "text"
                    :data-testid "email-input"}))))))

(defui form-field-role []
  ($ form-field
     {:label "Role"
      :err-msg (form/use-error-message [:roleId])}
     (r/as-element
      [dropdown
       (merge (form/use-bind-control [:roleId])
              {:options (use-subscribe [:form.user/role-options])
               :data-testid "role-select"})])))

(defui ocp-footer
  [{:keys [mode user]}]
  ($ :<>
     (when (= mode :edit)
       ($ Button
          {:variant "contained"
           :color "error"
           :onClick #(rf/dispatch [:modal/open {:id :user/confirm-delete
                                                :props user}])}
          "Remove User"))
     ($ Button
        {:variant "contained"
         :data-testid "create-user-button"
         :type "submit"}
        (if (= :edit mode)
          "Save User"
          "Create User"))))

(defocp user-ocp :user/crud [{:keys [user]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.user/init-form user])
                    (fn []
                      (rf/dispatch [:form.user/destroy])))
                  [user])
  (let [mode (use-subscribe [:form.user/mode])]
    ($ ocp
       {:title (if user "Edit User" "Create a new User")
        :footer ($ ocp-footer {:mode mode :user user})
        :on-submit #(rf/dispatch [:form.user/submit])}
       (when (= mode :edit)
         ($ form-field
            {:label "Name"}
            ($ :p (:name user))))
       ($ form-field-email {:mode mode})
       ($ form-field-role))))

(defmodal confirm-delete :user/confirm-delete
  [{:keys [name email]}]
  [form-dialog
   {:on-submit #(rf/dispatch [:form.user/delete])
    :submit-button-label "Remove access"
    :title (str "Remove access rights for " name)}
   [:<>
    [:p
     "Are you sure you want to retract the access rights for this user?"]
    [:p
     "You can restore access later by adding the e-mail address: " [:b email]]]])
